/**
 * Al envolver un componente React en la funcion withStyles de Material-UI
 * las referencias se pasan mediante le parametro innerRef, no ref
 */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';

class Grid extends Component {

  updateFramesValues = () => {
    const {classNameDiv, onClick, srcChange} = this.props;

    onClick(classNameDiv, srcChange)
  }

  render() {
    const {
      className,
      classNameDiv,
      checkedI,
      label,
      selected,
      src,
      srcChange
    } = this.props;
    const classNameI = selected === 'active'
      ? checkedI
      : '';
    const srcFinal = classNameI === ''
      ? srcChange
      : src;
    return (<div className={classNameDiv}>
      <a href="#" className={className} onClick={this.updateFramesValues} style={{
          'maxHeight' : '98px'
        }}>
        <img src={srcFinal} alt='Final'/>
        <label style={{
            'textAlign' : 'center'
          }}>{label}</label>
        <i className={classNameI}></i>
      </a>
    </div>);
  }
}

export default Grid;
